/* EcoClean® — MOTION « XRC » (XRC, 30/09/2026, v2). GSAP + ScrollTrigger, mêmes courbes que xrc.fr.
   Titres révélés mot à mot, contraste typo (condensé / fine italique), surtitres qui se resserrent,
   cartes en cascade, avant/après qui s'ouvrent au scroll, boutons aimantés (souris uniquement).
   Sans GSAP, en mode éditeur ou avec « réduire les animations » : rien n'est caché. Conçu par XRC · xrc.fr */
(function () {
  var d = document, R = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && Shopify.designMode;
  if (reduce || editor || !window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  R.classList.add('ec-m');

  var HEADS = 'main h1, main h2.ec-h2, main .vs__title, main .hb-name';
  var fine = window.matchMedia && matchMedia('(pointer:fine)').matches;
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* 1. Contraste typographique XRC : la fin du titre (après « — » ou la 1re virgule) passe en fine italique */
  gsap.utils.toArray(HEADS).forEach(function (h) {
    if (h.children.length || h.classList.contains('hb-name')) return;
    var t = h.textContent.replace(/\s+/g, ' ').trim(), i = t.indexOf(' — '), cut = 0;
    if (i > 0) cut = i + 3; else { i = t.indexOf(', '); if (i > 0 && i < t.length - 4) cut = i + 2; }
    if (cut) h.innerHTML = esc(t.slice(0, cut).trim()) + ' <span class="ec-alt">' + esc(t.slice(cut)) + '</span>';
  });

  /* 2. Découpe en mots masqués (les blocs en dégradé restent entiers pour garder le background-clip) */
  function wrap() {
    var w = d.createElement('span'), i = d.createElement('span');
    w.className = 'ec-w'; i.className = 'ec-wi'; w.appendChild(i); return { w: w, i: i };
  }
  function split(el) {
    Array.prototype.slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var f = d.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { f.appendChild(d.createTextNode(' ')); return; }
          var o = wrap(); o.i.textContent = p; f.appendChild(o.w);
        });
        n.parentNode.replaceChild(f, n);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') {
        if (n.classList.contains('ec-grad') || n.classList.contains('hb-name-2')) {
          var o = wrap(); n.parentNode.insertBefore(o.w, n); o.i.appendChild(n);
        } else split(n);
      }
    });
  }
  gsap.utils.toArray(HEADS).forEach(function (h) {
    split(h);
    gsap.from(h.querySelectorAll('.ec-wi'), {
      yPercent: 118, rotate: 2, duration: 1.15, ease: 'expo.out', stagger: 0.055,
      scrollTrigger: { trigger: h, start: 'top 88%', once: true }
    });
  });

  /* 3. Surtitres : l'espacement se resserre (effet .case-brand de xrc.fr) */
  gsap.utils.toArray('main .ec-kick, main .vs__eyebrow, main .hb-eyebrow').forEach(function (k) {
    gsap.from(k, { letterSpacing: '.6em', opacity: 0, duration: 1.5, ease: 'expo.out', scrollTrigger: { trigger: k, start: 'top 90%', once: true } });
  });

  /* 4. Textes d'accroche et contenus de blocs */
  gsap.utils.toArray('main .vs__sub, main .rl__sub, main .xh__s, main .xh__cta, main .xh__proof, main .hb-benefit, main .ec-cta .ec-wrap > p, main .shop-meta, main .ec-google, main .cta-btns, main .ec-seeall').forEach(function (el) {
    gsap.from(el, { y: 28, opacity: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
  });

  /* 5. Cartes en cascade (remplace l'ancien fondu .ec-stagger) */
  gsap.utils.toArray('main .ec-stagger, main .vs__grid').forEach(function (g) {
    var items = g.children;
    if (!items.length) return;
    gsap.from(items, { y: 70, opacity: 0, scale: 0.965, duration: 1.1, ease: 'expo.out', stagger: 0.08, scrollTrigger: { trigger: g, start: 'top 88%', once: true } });
  });

  /* 6. Avant / après : le cadre s'ouvre au scroll (effet showreel xrc.fr) */
  gsap.utils.toArray('main .ba-wrap').forEach(function (b) {
    gsap.fromTo(b, { clipPath: 'inset(7% 7% 7% 7% round 36px)' }, {
      clipPath: 'inset(0% 0% 0% 0% round 18px)', ease: 'none',
      scrollTrigger: { trigger: b, start: 'top bottom', end: 'center 65%', scrub: 1 }
    });
  });

  /* 6b. Hero : la vidéo zoome et le texte s'efface en douceur au scroll (hero xrc.fr) */
  if (d.querySelector('.xh')) {
    gsap.to('.xh__v', { scale: 1.22, ease: 'none', scrollTrigger: { trigger: '.xh', start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to('.xh__in', { yPercent: -14, opacity: 0.15, ease: 'none', scrollTrigger: { trigger: '.xh', start: 'top top', end: 'bottom top', scrub: true } });
  }

  /* 6c. Texte qui défile : la vitesse et le sens suivent le scroll */
  var mqs = gsap.utils.toArray('.mq__track').map(function (t) { return t.getAnimations && t.getAnimations()[0]; }).filter(Boolean);
  if (mqs.length) {
    var rate = 1, target = 1, dir = 1;
    ScrollTrigger.create({ onUpdate: function (self) { dir = self.direction; target = dir * (1 + Math.min(Math.abs(self.getVelocity()) / 350, 5)); } });
    gsap.ticker.add(function () { target += (dir - target) * 0.05; rate += (target - rate) * 0.12; mqs.forEach(function (a) { a.playbackRate = rate; }); });
  }

  /* 6d. Vidéos des réseaux : piste horizontale épinglée sur ordinateur (effet viral xrc.fr) */
  var rt = d.querySelector('.rl__track');
  if (rt) {
    gsap.matchMedia().add('(min-width: 990px)', function () {
      var dist = function () { return Math.max(0, rt.scrollWidth - window.innerWidth); };
      rt.style.overflow = 'visible';
      var tl = gsap.timeline({ scrollTrigger: { trigger: '.rl__pin', start: 'center center', end: function () { return '+=' + (dist() + 300); }, pin: true, scrub: 1, invalidateOnRefresh: true } });
      tl.fromTo(rt, { x: function () { return window.innerWidth * 0.12; } }, { x: function () { return -dist(); }, ease: 'none', duration: 1 }, 0)
        .fromTo(rt.querySelectorAll('.rl__card'), { rotationY: -24, z: -140, opacity: 0.45 }, { rotationY: 0, z: 0, opacity: 1, stagger: 0.08, duration: 0.35, ease: 'power2.out' }, 0);
      return function () { rt.style.overflow = ''; };
    });
  }

  /* 6e. Grands numéros de section en contour, en parallaxe (chapitres xrc.fr) */
  gsap.utils.toArray('main .ec-head-row, main .rl__head, main .ec-head').forEach(function (h, i) {
    var n = d.createElement('span'); n.className = 'ec-num'; n.setAttribute('aria-hidden', 'true');
    n.textContent = (i + 1 < 10 ? '0' : '') + (i + 1); h.classList.add('ec-numd'); h.insertBefore(n, h.firstChild);
    gsap.fromTo(n, { yPercent: 25, opacity: 0 }, { yPercent: -25, opacity: 1, ease: 'none', scrollTrigger: { trigger: h, start: 'top bottom', end: 'bottom top', scrub: 1 } });
  });

  /* 7. Boutons aimantés + cartes inclinées (souris uniquement, comme xrc.fr) */
  if (fine) {
    gsap.utils.toArray('main .ec-btn, main .hb-add, main .vs__all, main .shop-meta .cta').forEach(function (b) {
      b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.22, y: (e.clientY - r.top - r.height / 2) * 0.32, duration: 0.4, ease: 'power3.out' }); });
      b.addEventListener('mouseleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1, 0.4)' }); });
    });
    gsap.utils.toArray('main .uc').forEach(function (c) {
      c.addEventListener('mousemove', function (e) { var r = c.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5; gsap.to(c, { rotationY: px * 7, rotationX: -py * 7, transformPerspective: 900, duration: 0.6, ease: 'power3.out' }); });
      c.addEventListener('mouseleave', function () { gsap.to(c, { rotationY: 0, rotationX: 0, duration: 0.9, ease: 'power3.out' }); });
    });
  }

  /* 8. Fine barre de progression de lecture */
  var bar = d.createElement('div'); bar.className = 'ec-progress'; bar.setAttribute('aria-hidden', 'true'); d.body.appendChild(bar);
  gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: d.body, start: 'top top', end: 'bottom bottom', scrub: 0.3 } });

  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();